export default __webpack_public_path__ + "static/media/personalization.3a52eab5.svg";